module.exports = __webpack_public_path__ + "img/icon_jixiao.660feb6c.png";